import { render, staticRenderFns } from "./com_shortAnswer.vue?vue&type=template&id=2ff2e6cd&scoped=true&"
import script from "./com_shortAnswer.vue?vue&type=script&lang=js&"
export * from "./com_shortAnswer.vue?vue&type=script&lang=js&"
import style0 from "./com_shortAnswer.vue?vue&type=style&index=0&id=2ff2e6cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff2e6cd",
  null
  
)

export default component.exports